import React from 'react';

import './ListCell.scss';

export default function ListCellSkeleton() {
  return (
    <div className="ListCell--skeleton">
      <div className="ListCell__Button">
        <div className="ListCell__IconWrapper skeleton" />

        <div className="ListCell__TextContainer">
          <div className="ListCell__HeaderText skeleton" />
          <div className="ListCell__BodyText skeleton" />
        </div>

        <div className="ListCell__CheckmarkContainer">
          <div className="ListCell__Checkmark_Empty" />
        </div>
      </div>
    </div>
  );
}

ListCellSkeleton.displayName = 'ListCellSkeleton';
